const IsProd = process.env.NODE_ENV === "production";
export default { IsProd };
